module.exports = __webpack_public_path__ + "img/logo-nuhou-2048-transparent.a9ba5575.png";